/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as StartImport } from './routes/start'
import { Route as MembersImport } from './routes/members'
import { Route as LoginImport } from './routes/login'
import { Route as MembersIndexImport } from './routes/members.index'
import { Route as MembersSearchImport } from './routes/members.search'
import { Route as MembersEnrollImport } from './routes/members.enroll'
import { Route as MembersMemberIdImport } from './routes/members.$memberId'

// Create Virtual Routes

const IndexLazyImport = createFileRoute('/')()

// Create/Update Routes

const StartRoute = StartImport.update({
  path: '/start',
  getParentRoute: () => rootRoute,
} as any)

const MembersRoute = MembersImport.update({
  path: '/members',
  getParentRoute: () => rootRoute,
} as any)

const LoginRoute = LoginImport.update({
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const IndexLazyRoute = IndexLazyImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))

const MembersIndexRoute = MembersIndexImport.update({
  path: '/',
  getParentRoute: () => MembersRoute,
} as any)

const MembersSearchRoute = MembersSearchImport.update({
  path: '/search',
  getParentRoute: () => MembersRoute,
} as any)

const MembersEnrollRoute = MembersEnrollImport.update({
  path: '/enroll',
  getParentRoute: () => MembersRoute,
} as any)

const MembersMemberIdRoute = MembersMemberIdImport.update({
  path: '/$memberId',
  getParentRoute: () => MembersRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexLazyImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginImport
      parentRoute: typeof rootRoute
    }
    '/members': {
      id: '/members'
      path: '/members'
      fullPath: '/members'
      preLoaderRoute: typeof MembersImport
      parentRoute: typeof rootRoute
    }
    '/start': {
      id: '/start'
      path: '/start'
      fullPath: '/start'
      preLoaderRoute: typeof StartImport
      parentRoute: typeof rootRoute
    }
    '/members/$memberId': {
      id: '/members/$memberId'
      path: '/$memberId'
      fullPath: '/members/$memberId'
      preLoaderRoute: typeof MembersMemberIdImport
      parentRoute: typeof MembersImport
    }
    '/members/enroll': {
      id: '/members/enroll'
      path: '/enroll'
      fullPath: '/members/enroll'
      preLoaderRoute: typeof MembersEnrollImport
      parentRoute: typeof MembersImport
    }
    '/members/search': {
      id: '/members/search'
      path: '/search'
      fullPath: '/members/search'
      preLoaderRoute: typeof MembersSearchImport
      parentRoute: typeof MembersImport
    }
    '/members/': {
      id: '/members/'
      path: '/'
      fullPath: '/members/'
      preLoaderRoute: typeof MembersIndexImport
      parentRoute: typeof MembersImport
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren({
  IndexLazyRoute,
  LoginRoute,
  MembersRoute: MembersRoute.addChildren({
    MembersMemberIdRoute,
    MembersEnrollRoute,
    MembersSearchRoute,
    MembersIndexRoute,
  }),
  StartRoute,
})

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/login",
        "/members",
        "/start"
      ]
    },
    "/": {
      "filePath": "index.lazy.tsx"
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/members": {
      "filePath": "members.tsx",
      "children": [
        "/members/$memberId",
        "/members/enroll",
        "/members/search",
        "/members/"
      ]
    },
    "/start": {
      "filePath": "start.tsx"
    },
    "/members/$memberId": {
      "filePath": "members.$memberId.tsx",
      "parent": "/members"
    },
    "/members/enroll": {
      "filePath": "members.enroll.tsx",
      "parent": "/members"
    },
    "/members/search": {
      "filePath": "members.search.tsx",
      "parent": "/members"
    },
    "/members/": {
      "filePath": "members.index.tsx",
      "parent": "/members"
    }
  }
}
ROUTE_MANIFEST_END */
